import dayjs from "dayjs";
function healthyWins(entries) {
  const days = /* @__PURE__ */ new Set();
  let total = 0;
  entries.forEach(
    (e) => e.flips.forEach((f) => {
      if (f.copingStyle === "healthy") {
        total += 1;
        days.add(dayjs(e.timestamp).format("YYYY-MM-DD"));
      }
    })
  );
  let streak = 0;
  let d = dayjs();
  if (!days.has(d.format("YYYY-MM-DD"))) d = d.subtract(1, "day");
  while (days.has(d.format("YYYY-MM-DD"))) {
    streak += 1;
    d = d.subtract(1, "day");
  }
  return { total, streak };
}
const healthyWinMessage = (w) => `Healthy Adult win! \u{1F331} That's ${w.total} so far${w.streak > 1 ? ` \xB7 ${w.streak}-day growth streak` : ""}.`;
export {
  healthyWinMessage,
  healthyWins
};
